import React from "react";
import avatar from "../../assets/avatar.png";

const Notification = ({ setOpenNotify }) => {
  return (
    <>
      <ul>
        {[1, 2, 3, 4, 5, 6, 7, 8].map((d) => (
          <li key={d} onClick={() => setOpenNotify(false)}>
            <div className="image">
              <img src={avatar} width="100%" alt="avatar" />
            </div>
            <div className="notification_content">
              <h2>Withdraw Request</h2>
              <p>12 Mar, 2022 - 02:15PM</p>
            </div>
          </li>
        ))}
      </ul>
    </>
  );
};

export default Notification;
